export default "__VITE_ASSET__a2f8865e__"